import { useLocalStore } from 'mobx-react-lite';
import { useEffect } from 'react';

import Entities from 'STORE';
import { InputPanel } from 'STORE/InputPanelsStore/InputPanel/InputPanel';

interface IInputPanelButtonsPresenter {
  timer: ReturnType<typeof setInterval> | null;
  isSlowMode: boolean;
  remainingSecond: number;
  checkSlowMode(): void;
  isShowRecordPanel: boolean;
  isShowVoiceButton: boolean;
  isShowSubmitButton: boolean;
  isShowScheduleButton: boolean;
  inputPanel: InputPanel | null;
}

export const useInputPanelButtonsPresenter = (): IInputPanelButtonsPresenter => {
  const presenter = useLocalStore<IInputPanelButtonsPresenter>(() => ({
    timer: null,
    isSlowMode: false,
    remainingSecond: 0,

    checkSlowMode(): void {
      if (presenter.timer) {
        clearTimeout(presenter.timer);
      }
      presenter.isSlowMode = false;
      const remainingTime = Entities.clientConfig.slowMode.endSlowModeTs - Date.now();
      if (remainingTime > 0) {
        presenter.isSlowMode = true;
        presenter.remainingSecond = Math.floor(remainingTime / 1000) + 1; // +1 do not show 00:00
        presenter.timer = setTimeout(presenter.checkSlowMode, 1000);
      }
    },

    get isShowRecordPanel(): boolean {
      return Boolean(
        presenter.inputPanel?.voice?.isPreviewMode || presenter.inputPanel?.voice?.isRecording
      );
    },

    get isShowVoiceButton(): boolean {
      return Boolean(
        !presenter.isSlowMode &&
          !presenter.inputPanel?.isEditMode &&
          !presenter.isShowRecordPanel &&
          presenter.inputPanel?.isEmptyValue
      );
    },

    get isShowSubmitButton(): boolean {
      return !presenter.isShowVoiceButton && !presenter.inputPanel?.group?.isSchedule;
    },

    get isShowScheduleButton(): boolean {
      return !presenter.isShowVoiceButton && !!presenter.inputPanel?.group?.isSchedule;
    },

    get inputPanel(): InputPanel | null {
      return Entities.InputPanelsStore.activeInputPanel;
    },
  }));

  useEffect(() => {
    presenter.checkSlowMode();
    return () => {
      if (presenter.timer) {
        clearTimeout(presenter.timer);
      }
    };
  }, [Entities.clientConfig.slowMode]);

  return presenter;
};
